
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5Krdf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $853df67b1c2afe8a$var$contentTitleStyles = (0, $buxP3.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginRight: 'space.075'
});
const $853df67b1c2afe8a$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$aaf6264d06ddc4ce = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $853df67b1c2afe8a$var$contentTitleStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $853df67b1c2afe8a$export$f80c710c106023ee = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1kk5Tklg8k _1UtDYzot27",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2XsHFMIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$var$nonStandardIconSize = '18px !important';
const $853df67b1c2afe8a$export$5159722bed5f8afe = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3YEZNOdnbC _37wbyuDIqT _39xV02NHnM _4ACwSf2w0z _2Qxi4n2w0z _0VARMJ2w0z _27VeLC2w0z",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$d69e1d473e997f8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isDisabled ? "50%" : "100%";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_y1fz7b": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1YKVNso4ed _2IR8s7fXap _4jynXzZqHV _456aSjS40j _2pzXhfZqHV _3QmkQaS40j",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
module.exports["TitleContainer"] = $853df67b1c2afe8a$export$35e09ba17cc51c69;
module.exports["ContentTitle"] = $853df67b1c2afe8a$export$aaf6264d06ddc4ce;
module.exports["DisabledContentTitle"] = $853df67b1c2afe8a$export$f80c710c106023ee;
module.exports["LozengeWrapper"] = $853df67b1c2afe8a$export$75180efdd3f4d9c2;
module.exports["ContentIconWrapper"] = $853df67b1c2afe8a$export$5159722bed5f8afe;
module.exports["MenuItemWrapper"] = $853df67b1c2afe8a$export$d69e1d473e997f8;

});

parcelRegister("bBaUQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dHSeC = parcelRequire("dHSeC");


var $dPJCf = parcelRequire("dPJCf");

const $de58db0b8f5ba7ec$export$7947243b7b7e6ed9 = (href)=>{
    const $ = (0, $bDgLe.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let t0;
    if ($[0] !== href || $[1] !== matchRoute || $[2] !== push) {
        t0 = (event)=>{
            const isSpaTransition = !!(0, $dHSeC.getSpaTransitionDetails)(event, {
                matchRoute: matchRoute
            });
            if (isSpaTransition && href) {
                event.preventDefault();
                push(href);
            }
        };
        $[0] = href;
        $[1] = matchRoute;
        $[2] = push;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["useHybridLinkClick"] = $de58db0b8f5ba7ec$export$7947243b7b7e6ed9;

});

parcelRegister("5nX81", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3e5T6 = parcelRequire("3e5T6");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $eVXGa = parcelRequire("eVXGa");


var $jMyy4 = parcelRequire("jMyy4");


var $98wxI = parcelRequire("98wxI");

const $4581e300b3378ab2$export$6ff73ccc41a81a83 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const forceSkipQuery = t0 === undefined ? false : t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const shouldSkipQuery = forceSkipQuery || !isAllowedToCreateWhiteboard || isPremium;
    let t1;
    if ($[0] !== shouldSkipQuery) {
        t1 = {
            fetchPolicy: "no-cache",
            skip: shouldSkipQuery
        };
        $[0] = shouldSkipQuery;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $3e5T6.default), {
        ...t1,
        __callerPackage__: "create-blank-fabric-page"
    });
    if (isPremium) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                deactivationIdentifier: undefined,
                paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE,
                showPaywallBeforeCreate: false
            };
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    const deactivationIdentifier = data?.paywallContentToDisable?.deactivationIdentifier;
    const t2 = data ? (0, $98wxI.PaywallStatus).ACTIVE : (0, $98wxI.PaywallStatus).UNSET;
    const t3 = Boolean(deactivationIdentifier);
    let t4;
    if ($[3] !== deactivationIdentifier || $[4] !== error || $[5] !== t2 || $[6] !== t3) {
        t4 = {
            deactivationIdentifier: deactivationIdentifier,
            error: error,
            paywallStatus: t2,
            showPaywallBeforeCreate: t3
        };
        $[3] = deactivationIdentifier;
        $[4] = error;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $4581e300b3378ab2$export$a8c755bcaca8c3d1 = (events, experience)=>{
    const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE));
    if (whiteboardExperienceStart) experience.succeed();
};
module.exports["useWhiteboardCreationPaywall"] = $4581e300b3378ab2$export$6ff73ccc41a81a83;
module.exports["collectStartCreateWhiteboardExperience"] = $4581e300b3378ab2$export$a8c755bcaca8c3d1;

});

parcelRegister("3e5T6", function(module, exports) {
/**
 * @generated SignedSource<<d37df0242947bc703f122d3b3e0e9fa5>>
 * @relayHash a28fc42ea6653f12be5a30a11af5dc0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebe1fceee5e2e21eb964959cab51d5a05dec7e313731928cfccaf6ee68f5726
const $4cca04f00a1366a4$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a28fc42ea6653f12be5a30a11af5dc0d",
            "id": "5ebe1fceee5e2e21eb964959cab51d5a05dec7e313731928cfccaf6ee68f5726",
            "metadata": {},
            "name": "useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$4cca04f00a1366a4$var$node.hash = "6ee03621e25bbc769cda83bd42cb5765";
var $4cca04f00a1366a4$export$2e2bcd8739ae039 = $4cca04f00a1366a4$var$node;
module.exports["default"] = $4cca04f00a1366a4$export$2e2bcd8739ae039;

});

parcelRegister("fCfQ7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9lIRA = parcelRequire("9lIRA");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7vK9E = parcelRequire("7vK9E");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5vUJ3 = parcelRequire("5vUJ3");


var $dPJCf = parcelRequire("dPJCf");


var $b3j2Y = parcelRequire("b3j2Y");


var $1ytiN = parcelRequire("1ytiN");


var $hQnHK = parcelRequire("hQnHK");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");


var $jMyy4 = parcelRequire("jMyy4");


var $98wxI = parcelRequire("98wxI");

const $804515fdfa3a1f20$var$SCREEN_NAME = `${(0, $hQnHK.WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX)}upfrontDialog`;
const $804515fdfa3a1f20$var$i18n = (0, $kSwu1.defineMessages)({
    bodyAdminStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    bodyAdminFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    createWhiteboard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.createWhiteboard",
        defaultMessage: "Create whiteboard"
    },
    defaultTitle: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.defaultWhiteboardName",
        defaultMessage: "An older board will become view-only"
    },
    learnMore: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.learnMore",
        defaultMessage: "Learn about usage"
    },
    title: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.title",
        defaultMessage: "{whiteboardName} will become view-only"
    }
});
const $804515fdfa3a1f20$var$whiteboardLinkStyles = {
    root: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0ReiIH7zJH"
};
const $804515fdfa3a1f20$var$DialogTitle = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { href: href, name: name } = t0;
    const renderWhiteboardLink = $804515fdfa3a1f20$var$_temp;
    let t1;
    if ($[0] !== href || $[1] !== name) {
        t1 = ()=>{
            if (!name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$804515fdfa3a1f20$var$i18n.defaultTitle,
                tagName: "span"
            });
            const whiteboardName_0 = href ? renderWhiteboardLink(`${(0, $1NBp8.WIKI).toUrl()}${href}`, name) : name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$804515fdfa3a1f20$var$i18n.title,
                values: {
                    whiteboardName: whiteboardName_0
                }
            });
        };
        $[0] = href;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    const getTitleText = t1;
    let t2;
    if ($[3] !== getTitleText) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "paywall-title"
        }, getTitleText());
        $[3] = getTitleText;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $804515fdfa3a1f20$export$9736e1fe2430fa6 = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { onClose: onClose, onCloseComplete: onCloseComplete, buildWhiteboardCreationLink: buildWhiteboardCreationLink } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const sessionData = (0, $bQm3c.useSessionData)();
    const edition = sessionData?.edition;
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            fetchPolicy: "no-cache"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $9lIRA.default), {
        ...t1,
        __callerPackage__: "create-blank-fabric-page"
    });
    let deactivationIdentifier;
    let link;
    let t2;
    let title;
    if ($[1] !== buildWhiteboardCreationLink || $[2] !== data?.paywallContentToDisable) {
        ({ link: link, title: title, deactivationIdentifier: deactivationIdentifier } = data?.paywallContentToDisable || {});
        t2 = buildWhiteboardCreationLink({
            deactivationIdentifier: deactivationIdentifier,
            paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE
        }, "-creationPaywall");
        $[1] = buildWhiteboardCreationLink;
        $[2] = data?.paywallContentToDisable;
        $[3] = deactivationIdentifier;
        $[4] = link;
        $[5] = t2;
        $[6] = title;
    } else {
        deactivationIdentifier = $[3];
        link = $[4];
        t2 = $[5];
        title = $[6];
    }
    const creationHref = t2;
    let t3;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== creationHref || $[9] !== deactivationIdentifier || $[10] !== error || $[11] !== loading || $[12] !== onClose || $[13] !== onCloseComplete || $[14] !== push) {
        t3 = ()=>{
            if (!loading && !error && !deactivationIdentifier) {
                push(creationHref);
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "autoCreate",
                        actionSubject: "activeSlotAvailableAfterRenderingCreationPaywall",
                        source: $804515fdfa3a1f20$var$SCREEN_NAME
                    }
                }).fire();
                onClose();
                onCloseComplete();
            }
        };
        t4 = [
            deactivationIdentifier,
            loading,
            error,
            creationHref,
            onClose,
            onCloseComplete,
            push,
            createAnalyticsEvent
        ];
        $[7] = createAnalyticsEvent;
        $[8] = creationHref;
        $[9] = deactivationIdentifier;
        $[10] = error;
        $[11] = loading;
        $[12] = onClose;
        $[13] = onCloseComplete;
        $[14] = push;
        $[15] = t3;
        $[16] = t4;
    } else {
        t3 = $[15];
        t4 = $[16];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[17] !== onClose || $[18] !== onCloseComplete) {
        t5 = ()=>{
            onClose();
            onCloseComplete();
        };
        $[17] = onClose;
        $[18] = onCloseComplete;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== creationHref || $[21] !== t5) {
        t6 = {
            actionSubjectId: "whiteboardPaywallCreateNewWhiteboardButton",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.createWhiteboard,
            href: creationHref,
            onClick: t5,
            target: "_self"
        };
        $[20] = creationHref;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    const creationLink = t6;
    let t7;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            actionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID),
            href: "https://support.atlassian.com/confluence-cloud/docs/understand-confluence-whiteboards-plans-and-features/",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.learnMore
        };
        $[23] = t7;
    } else t7 = $[23];
    const learnMoreLink = t7;
    let bodyMessage;
    if (edition === (0, $euL71.ConfluenceEdition).STANDARD) bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminStandard : $804515fdfa3a1f20$var$i18n.bodyEndUserStandard;
    else bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminFree : $804515fdfa3a1f20$var$i18n.bodyEndUserFree;
    let t8;
    if ($[24] !== link || $[25] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($804515fdfa3a1f20$var$DialogTitle, {
            href: link,
            name: title
        });
        $[24] = link;
        $[25] = title;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== bodyMessage) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...bodyMessage,
            tagName: "p"
        });
        $[27] = bodyMessage;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== error) {
        t10 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: error
        }));
        $[29] = error;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== creationLink || $[32] !== onClose || $[33] !== onCloseComplete || $[34] !== t10 || $[35] !== t8 || $[36] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5vUJ3.WhiteboardsActiveBoardLimitModal), {
            learnMoreLink: learnMoreLink,
            onClose: onClose,
            onCloseComplete: onCloseComplete,
            secondaryLink: creationLink,
            source: $804515fdfa3a1f20$var$SCREEN_NAME,
            title: t8,
            upgradeEditionActionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID)
        }, t9, t10);
        $[31] = creationLink;
        $[32] = onClose;
        $[33] = onCloseComplete;
        $[34] = t10;
        $[35] = t8;
        $[36] = t9;
        $[37] = t11;
    } else t11 = $[37];
    return t11;
};
function $804515fdfa3a1f20$var$_temp(url, whiteboardName) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        xcss: $804515fdfa3a1f20$var$whiteboardLinkStyles.root,
        href: url
    }, whiteboardName);
}
module.exports["WhiteboardCreationPaywallDialog"] = $804515fdfa3a1f20$export$9736e1fe2430fa6;

});

parcelRegister("9lIRA", function(module, exports) {
/**
 * @generated SignedSource<<7b196cb51b7625c92580f9b691726e9b>>
 * @relayHash 614d396c8e6ecec858e588739a73cf6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13d9e6a9b9b423343dfe5d66aeff60a66cd46a6e0bd034b8102b368d14081e5c
const $b425f8459d09338b$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "614d396c8e6ecec858e588739a73cf6b",
            "id": "13d9e6a9b9b423343dfe5d66aeff60a66cd46a6e0bd034b8102b368d14081e5c",
            "metadata": {},
            "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$b425f8459d09338b$var$node.hash = "0113a00e3f9a0d6c607ac3e96cb84758";
var $b425f8459d09338b$export$2e2bcd8739ae039 = $b425f8459d09338b$var$node;
module.exports["default"] = $b425f8459d09338b$export$2e2bcd8739ae039;

});

parcelRegister("fSDMD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $60Yxm = parcelRequire("60Yxm");


var $hLP6B = parcelRequire("hLP6B");


var $9ivsj = parcelRequire("9ivsj");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $bK5Dy = parcelRequire("bK5Dy");


var $7aRa9 = parcelRequire("7aRa9");


var $4R3wx = parcelRequire("4R3wx");


var $9uAPw = parcelRequire("9uAPw");


var $dPJCf = parcelRequire("dPJCf");


var $7QM6o = parcelRequire("7QM6o");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $h7OOD = parcelRequire("h7OOD");


var $5Krdf = parcelRequire("5Krdf");

const $30211231850ecfc1$var$i18n = (0, $kSwu1.defineMessages)({
    openingLoomRecorder: {
        id: "create-blank-fabric-page.create.content.loom-video.opening-loom-recorder",
        defaultMessage: "Opening Loom recorder"
    },
    loomVideoTitle: {
        id: "create-blank-fabric-page.create.content.loom-video.title",
        defaultMessage: "Loom video"
    }
});
const $30211231850ecfc1$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $30211231850ecfc1$export$fb281ae10f502d32 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "BETA",
            "CO_USE",
            "CROSS_JOIN"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return t0.includes(entryPointVariant);
};
const $30211231850ecfc1$var$RecordLoomPopoverItemComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { entryPointLocation: entryPointLocation, flags: flags, onClick: onClick, onRecorderOpenComplete: onRecorderOpenComplete, source: source, spaceKey: spaceKey, parentId: parentId, withFallback: t1, isDisabled: t2, location: t3 } = t0;
    const withFallback = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const location = t3 === undefined ? "" : t3;
    const intl = (0, $kSwu1.useIntl)();
    const prefersReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "record-loom-popover-item"
        };
        $[0] = t4;
    } else t4 = $[0];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t4);
    const prevIsOpeningRecorder = (0, $cozmU.useRef)(false);
    let t5;
    if ($[1] !== entryPointLocation || $[2] !== flags) {
        t5 = {
            entryPointLocation: entryPointLocation,
            flags: flags
        };
        $[1] = entryPointLocation;
        $[2] = flags;
        $[3] = t5;
    } else t5 = $[3];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, isOpeningRecorder: isOpeningRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)(t5);
    let t6;
    let t7;
    if ($[4] !== isOpeningRecorder || $[5] !== onRecorderOpenComplete) {
        t6 = ()=>{
            if (prevIsOpeningRecorder.current && !isOpeningRecorder) onRecorderOpenComplete?.();
            prevIsOpeningRecorder.current = isOpeningRecorder;
        };
        t7 = [
            isOpeningRecorder,
            onRecorderOpenComplete
        ];
        $[4] = isOpeningRecorder;
        $[5] = onRecorderOpenComplete;
        $[6] = t6;
        $[7] = t7;
    } else {
        t6 = $[6];
        t7 = $[7];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[8] !== createAnalyticsEvent || $[9] !== location || $[10] !== onClick || $[11] !== openLoomRecorder || $[12] !== parentId || $[13] !== push || $[14] !== source || $[15] !== spaceId || $[16] !== spaceKey || $[17] !== withFallback) {
        t8 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        ...withFallback && {
                            withFallback: withFallback
                        },
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $bK5Dy.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: location
            });
        };
        $[8] = createAnalyticsEvent;
        $[9] = location;
        $[10] = onClick;
        $[11] = openLoomRecorder;
        $[12] = parentId;
        $[13] = push;
        $[14] = source;
        $[15] = spaceId;
        $[16] = spaceKey;
        $[17] = withFallback;
        $[18] = t8;
    } else t8 = $[18];
    const handleClick = t8;
    let t9;
    if ($[19] !== enforceStorageLimit || $[20] !== handleClick) {
        t9 = enforceStorageLimit(handleClick);
        $[19] = enforceStorageLimit;
        $[20] = handleClick;
        $[21] = t9;
    } else t9 = $[21];
    const handleClickWithStorageEnforcement = t9;
    let t10;
    if ($[22] !== handleClickWithStorageEnforcement || $[23] !== intl || $[24] !== isDisabled || $[25] !== isLoomRecorderInitialized || $[26] !== isOpeningRecorder || $[27] !== prefersReducedMotion) {
        t10 = !isLoomRecorderInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLP6B.default), {
            hasIcon: true,
            isShimmering: !prefersReducedMotion,
            testId: "skeleton-create-menu-button-item"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h7OOD.LoadingPopoverItem), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Krdf.ContentIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $30211231850ecfc1$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }))),
            isLoading: isOpeningRecorder,
            loadingLabel: intl.formatMessage($30211231850ecfc1$var$i18n.openingLoomRecorder),
            onClick: handleClickWithStorageEnforcement,
            testId: "create-menu-button-item",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Krdf.TitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Krdf.ContentTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $30211231850ecfc1$var$i18n.loomVideoTitle)))));
        $[22] = handleClickWithStorageEnforcement;
        $[23] = intl;
        $[24] = isDisabled;
        $[25] = isLoomRecorderInitialized;
        $[26] = isOpeningRecorder;
        $[27] = prefersReducedMotion;
        $[28] = t10;
    } else t10 = $[28];
    const menuItem = t10;
    return menuItem;
};
const $30211231850ecfc1$export$4d5ee8c1efd60993 = (0, $7aRa9.withFlags)($30211231850ecfc1$var$RecordLoomPopoverItemComponent);
module.exports["useIsCreateMenuLoomRecorderEntryPointEnabled"] = $30211231850ecfc1$export$fb281ae10f502d32;
module.exports["RecordLoomPopoverItem"] = $30211231850ecfc1$export$4d5ee8c1efd60993;

});

parcelRegister("h7OOD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9d7Pd = parcelRequire("9d7Pd");


var $lfoFx = parcelRequire("lfoFx");


var $9GVkD = parcelRequire("9GVkD");

const $8acd43e7dd84c3a6$export$a0fbd5b601316213 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let children;
    let isLoading;
    let loadingLabel;
    let onClick;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, loadingLabel: loadingLabel, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = loadingLabel;
        $[4] = onClick;
        $[5] = props;
    } else {
        children = $[1];
        isLoading = $[2];
        loadingLabel = $[3];
        onClick = $[4];
        props = $[5];
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== onClick) {
        t1 = (e)=>{
            if (isLoading) return;
            onClick?.(e);
        };
        $[6] = isLoading;
        $[7] = onClick;
        $[8] = t1;
    } else t1 = $[8];
    const handleClick = t1;
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small"
        });
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== loadingLabel) {
        t3 = {
            "aria-disabled": true,
            "aria-label": loadingLabel,
            iconAfter: t2
        };
        $[10] = loadingLabel;
        $[11] = t3;
    } else t3 = $[11];
    const loadingProps = t3;
    const t4 = isLoading ? loadingLabel : undefined;
    let t5;
    if ($[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            role: "status"
        }, t4);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = isLoading && loadingProps;
    let t7;
    if ($[14] !== children || $[15] !== handleClick || $[16] !== props || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: handleClick,
            ...props,
            ...t6
        }, children);
        $[14] = children;
        $[15] = handleClick;
        $[16] = props;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t5 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t7);
        $[19] = t5;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["LoadingPopoverItem"] = $8acd43e7dd84c3a6$export$a0fbd5b601316213;

});

parcelRegister("70Hxb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fCAhy = parcelRequire("fCAhy");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $f33ad4d19c4f469c$export$54c1384e7af0d55e = ({ touchpointSource: touchpointSource, children: children })=>{
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const assistanceServiceParams = (0, $cozmU.useMemo)(()=>({
            product: 'confluence',
            experienceId: 'confluence-smart-create',
            touchpointSource: touchpointSource,
            siteId: cloudId
        }), [
        cloudId,
        touchpointSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCAhy.PromptSuggestions), {
        includeThirdParty: isRovoEnabled || !(0, $9wGTI.fg)('rovo_chat_3p_prompt_entitlement_guard'),
        assistanceServiceParams: assistanceServiceParams
    }, children);
};
module.exports["ConfluencePromptSuggestions"] = $f33ad4d19c4f469c$export$54c1384e7af0d55e;

});

parcelRegister("fCAhy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4A67J = parcelRequire("4A67J");


var $P6VbT = parcelRequire("P6VbT");

const $c4e8989ad67d699d$var$PENDING_DECISION = {
    enable3pPrompt: false,
    ready: false
};
const $c4e8989ad67d699d$var$ORDINARY_DECISION = {
    enable3pPrompt: false,
    ready: true
};
const $c4e8989ad67d699d$export$742cab555fb72a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { includeThirdParty: includeThirdParty, children: children, assistanceServiceParams: assistanceServiceParams } = t0;
    const hasReportedExposureRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== includeThirdParty) {
        t1 = {
            includeThirdParty: includeThirdParty,
            decision: $c4e8989ad67d699d$var$PENDING_DECISION
        };
        $[0] = includeThirdParty;
        $[1] = t1;
    } else t1 = $[1];
    const [controllerState, setControllerState] = (0, $cozmU.useState)(t1);
    if (controllerState.includeThirdParty !== includeThirdParty) setControllerState({
        includeThirdParty: includeThirdParty,
        decision: $c4e8989ad67d699d$var$PENDING_DECISION
    });
    let t2;
    if ($[2] !== includeThirdParty) {
        t2 = (decision)=>{
            setControllerState((current)=>current.includeThirdParty === includeThirdParty && current.decision.enable3pPrompt === decision.enable3pPrompt && current.decision.ready === decision.ready ? current : {
                    includeThirdParty: includeThirdParty,
                    decision: decision
                });
        };
        $[2] = includeThirdParty;
        $[3] = t2;
    } else t2 = $[3];
    const onDecisionChange = t2;
    const t3 = includeThirdParty ? controllerState.decision : $c4e8989ad67d699d$var$ORDINARY_DECISION;
    let t4;
    if ($[4] !== assistanceServiceParams || $[5] !== includeThirdParty || $[6] !== t3) {
        t4 = {
            assistanceServiceParams: assistanceServiceParams,
            includeThirdParty: includeThirdParty,
            thirdPartyPrompt: t3
        };
        $[4] = assistanceServiceParams;
        $[5] = includeThirdParty;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const suggestions = (0, $P6VbT.usePromptSuggestionsWithDecision)(t4);
    let t5;
    if ($[8] !== assistanceServiceParams || $[9] !== includeThirdParty || $[10] !== onDecisionChange) {
        t5 = includeThirdParty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4A67J.ThirdPartyPromptSuggestionsController), {
            assistanceServiceParams: assistanceServiceParams,
            onDecisionChange: onDecisionChange,
            hasReportedExposureRef: hasReportedExposureRef
        });
        $[8] = assistanceServiceParams;
        $[9] = includeThirdParty;
        $[10] = onDecisionChange;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== children || $[13] !== suggestions) {
        t6 = children(suggestions);
        $[12] = children;
        $[13] = suggestions;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: "consumer"
        }, t6);
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t5 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t7);
        $[17] = t5;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ includeThirdParty: includeThirdParty, children: children, assistanceServiceParams: assistanceServiceParams })=>{
    const hasReportedExposureRef = (0, $cozmU.useRef)(false);
    const [controllerState, setControllerState] = (0, $cozmU.useState)({
        includeThirdParty: includeThirdParty,
        decision: $c4e8989ad67d699d$var$PENDING_DECISION
    });
    // Do not reuse a previous controller's ready flag when it is mounted again.
    if (controllerState.includeThirdParty !== includeThirdParty) setControllerState({
        includeThirdParty: includeThirdParty,
        decision: $c4e8989ad67d699d$var$PENDING_DECISION
    });
    const onDecisionChange = (0, $cozmU.useCallback)((decision)=>{
        setControllerState((current)=>current.includeThirdParty === includeThirdParty && current.decision.enable3pPrompt === decision.enable3pPrompt && current.decision.ready === decision.ready ? current : {
                includeThirdParty: includeThirdParty,
                decision: decision
            });
    }, [
        includeThirdParty
    ]);
    const suggestions = (0, $P6VbT.usePromptSuggestionsWithDecision)({
        assistanceServiceParams: assistanceServiceParams,
        includeThirdParty: includeThirdParty,
        thirdPartyPrompt: includeThirdParty ? controllerState.decision : $c4e8989ad67d699d$var$ORDINARY_DECISION
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, includeThirdParty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4A67J.ThirdPartyPromptSuggestionsController), {
        assistanceServiceParams: assistanceServiceParams,
        onDecisionChange: onDecisionChange,
        hasReportedExposureRef: hasReportedExposureRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        key: "consumer"
    }, children(suggestions)));
};
module.exports["PromptSuggestions"] = $c4e8989ad67d699d$export$742cab555fb72a5;

});

parcelRegister("4A67J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $8VnnM = parcelRequire("8VnnM");


var $04dKE = parcelRequire("04dKE");

const $fb49f45188729492$var$useTilesDisplayed = (0, $kBr4q.createHook)((0, $8VnnM.store), {
    selector: (state)=>(state.primaryPrompts?.length ?? 0) > 0
});
const $fb49f45188729492$export$1f3ab62a47ab9738 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { assistanceServiceParams: assistanceServiceParams, onDecisionChange: onDecisionChange, hasReportedExposureRef: hasReportedExposureRef } = t0;
    const [tilesDisplayed] = $fb49f45188729492$var$useTilesDisplayed();
    let t1;
    if ($[0] !== assistanceServiceParams || $[1] !== hasReportedExposureRef || $[2] !== tilesDisplayed) {
        t1 = {
            assistanceServiceParams: assistanceServiceParams,
            tilesDisplayed: tilesDisplayed,
            hasReportedExposureRef: hasReportedExposureRef
        };
        $[0] = assistanceServiceParams;
        $[1] = hasReportedExposureRef;
        $[2] = tilesDisplayed;
        $[3] = t1;
    } else t1 = $[3];
    const { enable3pPrompt: enable3pPrompt, ready: ready } = (0, $04dKE.useThirdPartySuggestedPromptTile)(t1);
    let t2;
    let t3;
    if ($[4] !== enable3pPrompt || $[5] !== onDecisionChange || $[6] !== ready) {
        t2 = ()=>{
            onDecisionChange({
                enable3pPrompt: enable3pPrompt,
                ready: ready
            });
        };
        t3 = [
            enable3pPrompt,
            ready,
            onDecisionChange
        ];
        $[4] = enable3pPrompt;
        $[5] = onDecisionChange;
        $[6] = ready;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return null;
} : ({ assistanceServiceParams: assistanceServiceParams, onDecisionChange: onDecisionChange, hasReportedExposureRef: hasReportedExposureRef })=>{
    const [tilesDisplayed] = $fb49f45188729492$var$useTilesDisplayed();
    const { enable3pPrompt: enable3pPrompt, ready: ready } = (0, $04dKE.useThirdPartySuggestedPromptTile)({
        assistanceServiceParams: assistanceServiceParams,
        tilesDisplayed: tilesDisplayed,
        hasReportedExposureRef: hasReportedExposureRef
    });
    (0, $cozmU.useEffect)(()=>{
        onDecisionChange({
            enable3pPrompt: enable3pPrompt,
            ready: ready
        });
    }, [
        enable3pPrompt,
        ready,
        onDecisionChange
    ]);
    return null;
};
module.exports["ThirdPartyPromptSuggestionsController"] = $fb49f45188729492$export$1f3ab62a47ab9738;

});

parcelRegister("8VnnM", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $24YcB = parcelRequire("24YcB");


var $hEfoI = parcelRequire("hEfoI");

const $96465d54dfd5abb1$var$shuffleArray = (items)=>{
    const shuffled = [
        ...items
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[randomIndex]] = [
            shuffled[randomIndex],
            shuffled[i]
        ];
    }
    return shuffled;
};
const $96465d54dfd5abb1$var$shufflePromptBuckets = ({ primaryPrompts: primaryPrompts, secondaryPrompts: secondaryPrompts })=>{
    const shuffledPrompts = $96465d54dfd5abb1$var$shuffleArray([
        ...primaryPrompts,
        ...secondaryPrompts
    ]);
    return {
        primaryPrompts: (0, $24YcB.getPrimaryPrompts)(shuffledPrompts),
        secondaryPrompts: (0, $hEfoI.getSecondaryPrompts)(shuffledPrompts)
    };
};
const $96465d54dfd5abb1$var$getInitialState = ()=>({
        data: null,
        primaryPrompts: null,
        secondaryPrompts: null,
        isLoading: false,
        isPrimaryPromptsLoading: false,
        isSecondaryPromptsLoading: false,
        error: null
    });
const $96465d54dfd5abb1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    name: 'promptSuggestions',
    initialState: $96465d54dfd5abb1$var$getInitialState(),
    actions: {
        reset: ()=>({ setState: setState })=>{
                setState($96465d54dfd5abb1$var$getInitialState());
            },
        getState: ()=>({ getState: getState })=>getState(),
        setLoading: ()=>({ setState: setState })=>{
                setState({
                    data: null,
                    primaryPrompts: null,
                    secondaryPrompts: null,
                    isLoading: true,
                    isPrimaryPromptsLoading: true,
                    isSecondaryPromptsLoading: true,
                    error: null
                });
            },
        setPrimaryPrompts: (primaryPrompts)=>({ setState: setState })=>{
                setState({
                    primaryPrompts: primaryPrompts,
                    isPrimaryPromptsLoading: false
                });
            },
        setSecondaryPrompts: (secondaryPrompts)=>({ setState: setState })=>{
                setState({
                    secondaryPrompts: secondaryPrompts,
                    isSecondaryPromptsLoading: false
                });
            },
        setData: (data)=>({ setState: setState })=>{
                setState({
                    data: data,
                    isLoading: false
                });
            },
        shuffleSuggestions: ()=>({ getState: getState, setState: setState })=>{
                const { primaryPrompts: primaryPrompts, secondaryPrompts: secondaryPrompts, isPrimaryPromptsLoading: isPrimaryPromptsLoading, isSecondaryPromptsLoading: isSecondaryPromptsLoading } = getState();
                if (isPrimaryPromptsLoading || isSecondaryPromptsLoading || !primaryPrompts || !secondaryPrompts) return;
                const shuffledPrompts = $96465d54dfd5abb1$var$shufflePromptBuckets({
                    primaryPrompts: primaryPrompts,
                    secondaryPrompts: secondaryPrompts
                });
                setState(shuffledPrompts);
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error,
                    isLoading: false,
                    isPrimaryPromptsLoading: false,
                    isSecondaryPromptsLoading: false
                });
            }
    }
});
module.exports["store"] = $96465d54dfd5abb1$export$6f57813fe9f31bf9;

});

parcelRegister("24YcB", function(module, exports) {

var $1pcs9 = parcelRequire("1pcs9");

const $553124242e90c256$export$2f2d2a0fb73ca989 = (tiles)=>tiles.slice(0, (0, $1pcs9.PRIMARY_PROMPTS_COUNT));
module.exports["getPrimaryPrompts"] = $553124242e90c256$export$2f2d2a0fb73ca989;

});

parcelRegister("1pcs9", function(module, exports) {
const $adcd40144063b82a$export$ed7c50136baccae7 = 3;
module.exports["PRIMARY_PROMPTS_COUNT"] = $adcd40144063b82a$export$ed7c50136baccae7;

});

parcelRegister("hEfoI", function(module, exports) {

var $1pcs9 = parcelRequire("1pcs9");

const $2dcd70b7b5c90134$export$e529a2203232b7ba = (tiles)=>tiles.slice((0, $1pcs9.PRIMARY_PROMPTS_COUNT));
module.exports["getSecondaryPrompts"] = $2dcd70b7b5c90134$export$e529a2203232b7ba;

});

parcelRegister("04dKE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $mW7G5 = parcelRequire("mW7G5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $7C3vQ = parcelRequire("7C3vQ");

/**
 * The modal touchpoint — the only surface that fires the Statsig exposure. The
 * preloads warm the same store but must not "see" the experiment, so the exposure
 * fires only here, when the modal opens.
 */ const $fcfdef2a236f4a40$var$EXPOSURE_TOUCHPOINT = 'smart-create-prompt-suggestions';
const $fcfdef2a236f4a40$export$dde7144858b2d0a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { assistanceServiceParams: assistanceServiceParams, tilesDisplayed: tilesDisplayed, hasReportedExposureRef: consumerHasReportedExposureRef } = t0;
    const { touchpointSource: touchpointSource } = assistanceServiceParams;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isExposureSurface = touchpointSource === $fcfdef2a236f4a40$var$EXPOSURE_TOUCHPOINT;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $mW7G5.expValNoExposure)("confluence_cwr_3p_connection_suggested_prompts", "cohort", "control");
        $[0] = t1;
    } else t1 = $[0];
    const cohort = t1;
    const isVariant = cohort === "variant_a" || cohort === "variant_b";
    const t2 = isExposureSurface || isVariant;
    let t3;
    if ($[1] !== assistanceServiceParams || $[2] !== t2) {
        t3 = {
            assistanceServiceParams: assistanceServiceParams,
            enabled: t2
        };
        $[1] = assistanceServiceParams;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { connectorsLoaded: connectorsLoaded, isEligible: isEligible, adminAllowed3pAppCount: adminAllowed3pAppCount, knowledgeSourceCount: knowledgeSourceCount, connectorsErrored: connectorsErrored } = (0, $7C3vQ.useThirdPartySuggestedPromptEligibility)(t3);
    const localHasReportedExposureRef = (0, $cozmU.useRef)(false);
    const hasReportedExposureRef = consumerHasReportedExposureRef ?? localHasReportedExposureRef;
    let t4;
    let t5;
    if ($[4] !== adminAllowed3pAppCount || $[5] !== connectorsErrored || $[6] !== connectorsLoaded || $[7] !== hasReportedExposureRef || $[8] !== isEligible || $[9] !== isExposureSurface || $[10] !== knowledgeSourceCount || $[11] !== sendAnalyticsEvent || $[12] !== tilesDisplayed || $[13] !== touchpointSource) {
        t4 = ()=>{
            if (!isExposureSurface || !tilesDisplayed || !connectorsLoaded || hasReportedExposureRef.current) return;
            hasReportedExposureRef.current = true;
            const exposedCohort = isEligible ? (0, $mW7G5.expVal)("confluence_cwr_3p_connection_suggested_prompts", "cohort", "control") : null;
            sendAnalyticsEvent({
                eventType: "track",
                action: "evaluated",
                actionSubject: "thirdPartySuggestedPromptEligibility",
                attributes: {
                    eligibility: isEligible ? "eligible" : connectorsErrored ? "connectors_unavailable" : "no_admin_allowed_3p_apps",
                    cohort: exposedCohort,
                    adminAllowed3pAppCount: adminAllowed3pAppCount,
                    knowledgeSourceCount: knowledgeSourceCount,
                    surface: touchpointSource
                }
            });
        };
        t5 = [
            isExposureSurface,
            tilesDisplayed,
            hasReportedExposureRef,
            connectorsLoaded,
            isEligible,
            connectorsErrored,
            adminAllowed3pAppCount,
            knowledgeSourceCount,
            touchpointSource,
            sendAnalyticsEvent
        ];
        $[4] = adminAllowed3pAppCount;
        $[5] = connectorsErrored;
        $[6] = connectorsLoaded;
        $[7] = hasReportedExposureRef;
        $[8] = isEligible;
        $[9] = isExposureSurface;
        $[10] = knowledgeSourceCount;
        $[11] = sendAnalyticsEvent;
        $[12] = tilesDisplayed;
        $[13] = touchpointSource;
        $[14] = t4;
        $[15] = t5;
    } else {
        t4 = $[14];
        t5 = $[15];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isVariant && isEligible;
    const t7 = !isVariant || connectorsLoaded;
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = {
            enable3pPrompt: t6,
            ready: t7
        };
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ assistanceServiceParams: assistanceServiceParams, tilesDisplayed: tilesDisplayed, hasReportedExposureRef: consumerHasReportedExposureRef })=>{
    const { touchpointSource: touchpointSource } = assistanceServiceParams;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const isExposureSurface = touchpointSource === $fcfdef2a236f4a40$var$EXPOSURE_TOUCHPOINT;
    // Cohort is a no-exposure read (in-memory, no network). Only variants A/B need the
    // connectors-derived flag, so only they wait on eligibility; control and everyone
    // else fetch suggestions immediately and still fire their exposure once connectors
    // settle in the background.
    const cohort = (0, $mW7G5.expValNoExposure)('confluence_cwr_3p_connection_suggested_prompts', 'cohort', 'control');
    const isVariant = cohort === 'variant_a' || cohort === 'variant_b';
    // Only load connectors where the 3P decision actually needs them: the exposure
    // surface (eligibility gates the exposure for every cohort, incl. control) or any
    // variant (which sends the fetch flag). Control on a preload surface does no
    // connectors work, so the create button doesn't fetch — or re-render — for it.
    const { connectorsLoaded: connectorsLoaded, isEligible: isEligible, adminAllowed3pAppCount: adminAllowed3pAppCount, knowledgeSourceCount: knowledgeSourceCount, connectorsErrored: connectorsErrored } = (0, $7C3vQ.useThirdPartySuggestedPromptEligibility)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: isExposureSurface || isVariant
    });
    // Fire the Statsig exposure — and the eligibility funnel event — once, when the
    // tiles are actually shown in the open modal. Only eligible users fire the
    // exposure via `expVal`; the funnel event is sent for everyone so the "admin
    // allowed no 3P apps → not in the experiment" segment is still counted.
    const localHasReportedExposureRef = (0, $cozmU.useRef)(false);
    const hasReportedExposureRef = consumerHasReportedExposureRef ?? localHasReportedExposureRef;
    (0, $cozmU.useEffect)(()=>{
        // Wait for connectors to load before firing: eligibility (and therefore whether
        // this user fires an exposure at all) is unknown until then. Control does not gate
        // its fetch on connectors, so its tiles can display first — without this guard an
        // eligible control user would latch an `isEligible: false` result and never expose.
        if (!isExposureSurface || !tilesDisplayed || !connectorsLoaded || hasReportedExposureRef.current) return;
        hasReportedExposureRef.current = true;
        const exposedCohort = isEligible ? (0, $mW7G5.expVal)('confluence_cwr_3p_connection_suggested_prompts', 'cohort', 'control') : null;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'evaluated',
            actionSubject: 'thirdPartySuggestedPromptEligibility',
            attributes: {
                eligibility: isEligible ? 'eligible' : connectorsErrored ? 'connectors_unavailable' : 'no_admin_allowed_3p_apps',
                cohort: exposedCohort,
                adminAllowed3pAppCount: adminAllowed3pAppCount,
                knowledgeSourceCount: knowledgeSourceCount,
                surface: touchpointSource
            }
        });
    }, [
        isExposureSurface,
        tilesDisplayed,
        hasReportedExposureRef,
        connectorsLoaded,
        isEligible,
        connectorsErrored,
        adminAllowed3pAppCount,
        knowledgeSourceCount,
        touchpointSource,
        sendAnalyticsEvent
    ]);
    return {
        enable3pPrompt: isVariant && isEligible,
        ready: !isVariant || connectorsLoaded
    };
};
module.exports["useThirdPartySuggestedPromptTile"] = $fcfdef2a236f4a40$export$dde7144858b2d0a4;

});

parcelRegister("7C3vQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7pCWA = parcelRequire("7pCWA");


var $ekfm7 = parcelRequire("ekfm7");


var $aCv1y = parcelRequire("aCv1y");

const $186fb27daddf5721$var$NOT_ELIGIBLE_DEFAULT = {
    isEligible: false,
    adminAllowed3pAppCount: 0,
    knowledgeSourceCount: 0,
    connectorsErrored: false
};
const $186fb27daddf5721$export$6dfb203cd898ea96 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { assistanceServiceParams: assistanceServiceParams, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== assistanceServiceParams) {
        t2 = {
            ...assistanceServiceParams,
            experienceId: "ai-mate"
        };
        $[0] = assistanceServiceParams;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== enabled || $[3] !== t2) {
        t3 = {
            assistanceServiceParams: t2,
            enabled: enabled
        };
        $[2] = enabled;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    (0, $ekfm7.useEnsureConnectorsLoaded)(t3);
    const [connectorsLoaded] = (0, $7pCWA.useConnectorsDataReady)();
    const [knowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [connectorsError] = (0, $7pCWA.useConnectorsError)();
    let t4;
    bb0: {
        if (!connectorsLoaded) {
            let t5;
            if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = {
                    connectorsLoaded: false,
                    ...$186fb27daddf5721$var$NOT_ELIGIBLE_DEFAULT
                };
                $[5] = t5;
            } else t5 = $[5];
            t4 = t5;
            break bb0;
        }
        const t5 = Boolean(connectorsError);
        let t6;
        if ($[6] !== knowledgeSources || $[7] !== t5) {
            t6 = (0, $aCv1y.getThirdPartyEligibility)({
                knowledgeSources: knowledgeSources,
                connectorsErrored: t5
            });
            $[6] = knowledgeSources;
            $[7] = t5;
            $[8] = t6;
        } else t6 = $[8];
        let t7;
        if ($[9] !== t6) {
            t7 = {
                connectorsLoaded: true,
                ...t6
            };
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t4 = t7;
    }
    return t4;
} : ({ assistanceServiceParams: assistanceServiceParams, enabled: enabled = true })=>{
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: {
            ...assistanceServiceParams,
            experienceId: 'ai-mate'
        },
        enabled: enabled
    });
    const [connectorsLoaded] = (0, $7pCWA.useConnectorsDataReady)();
    const [knowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [connectorsError] = (0, $7pCWA.useConnectorsError)();
    return (0, $cozmU.useMemo)(()=>{
        if (!connectorsLoaded) return {
            connectorsLoaded: false,
            ...$186fb27daddf5721$var$NOT_ELIGIBLE_DEFAULT
        };
        return {
            connectorsLoaded: true,
            ...(0, $aCv1y.getThirdPartyEligibility)({
                knowledgeSources: knowledgeSources,
                connectorsErrored: Boolean(connectorsError)
            })
        };
    }, [
        connectorsLoaded,
        knowledgeSources,
        connectorsError
    ]);
};
module.exports["useThirdPartySuggestedPromptEligibility"] = $186fb27daddf5721$export$6dfb203cd898ea96;

});

parcelRegister("P6VbT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bxkJA = parcelRequire("bxkJA");


var $lJ6db = parcelRequire("lJ6db");


var $8ikj4 = parcelRequire("8ikj4");

const $f0fba6bcbd23eb58$export$d4e601fb3008437c = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, thirdPartyPrompt: thirdPartyPrompt = {
    enable3pPrompt: false,
    ready: true
}, includeThirdParty: includeThirdParty = false })=>{
    const suggestions = (0, $8ikj4.usePromptSuggestionsState)({
        assistanceServiceInjectedParams: assistanceServiceInjectedParams,
        thirdPartyPrompt: thirdPartyPrompt
    });
    // A previous entitled surface may have warmed the shared store with a 3P tile.
    const { data: data, primaryPrompts: primaryPrompts, secondaryPrompts: secondaryPrompts } = suggestions;
    const ordinaryPrompts = (0, $cozmU.useMemo)(()=>{
        if (includeThirdParty) return {
            data: data,
            primaryPrompts: primaryPrompts,
            secondaryPrompts: secondaryPrompts
        };
        const withoutThirdParty = (prompts)=>prompts?.filter((prompt)=>prompt.source_content_type !== (0, $bxkJA.THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE)) ?? null;
        return {
            data: withoutThirdParty(data),
            primaryPrompts: withoutThirdParty(primaryPrompts),
            secondaryPrompts: withoutThirdParty(secondaryPrompts)
        };
    }, [
        data,
        primaryPrompts,
        secondaryPrompts,
        includeThirdParty
    ]);
    return {
        ...suggestions,
        ...ordinaryPrompts
    };
});
module.exports["usePromptSuggestionsWithDecision"] = $f0fba6bcbd23eb58$export$d4e601fb3008437c;

});

parcelRegister("8ikj4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");


var $bxkJA = parcelRequire("bxkJA");


var $jTKfH = parcelRequire("jTKfH");


var $24YcB = parcelRequire("24YcB");


var $hEfoI = parcelRequire("hEfoI");


var $1pcs9 = parcelRequire("1pcs9");


var $ewEzF = parcelRequire("ewEzF");


var $4ONgd = parcelRequire("4ONgd");


var $6UjGM = parcelRequire("6UjGM");


var $8VnnM = parcelRequire("8VnnM");

const $eb2a414d1f8098e3$var$TOTAL_PROMPT_SUGGESTIONS_COUNT = (0, $1pcs9.PRIMARY_PROMPTS_COUNT) + (0, $6UjGM.SECONDARY_PROMPTS_COUNT);
const $eb2a414d1f8098e3$var$STREAM_ERROR_MESSAGE_TYPE = 'ERROR';
/**
 * Builds the error for a backend `ERROR` message. The message is fixed so Sentry groups these
 * together; the details go in `errorAttributes`, which the experience tracker forwards to Sentry
 * and analytics.
 */ const $eb2a414d1f8098e3$var$createStreamError = (streamError)=>new (0, $jTKfH.FetchError)('Prompt suggestions stream returned an error', {
        statusCode: streamError.status_code,
        errorCode: streamError.message_template
    });
const $eb2a414d1f8098e3$var$parsePromptSuggestionsStream = async ({ generator: generator, maxTiles: maxTiles, onPrimaryPromptsReady: onPrimaryPromptsReady, onSecondaryPromptsReady: onSecondaryPromptsReady })=>{
    const tiles = [];
    // Unexpected message types are ignored for rendering, but we keep them so an empty result
    // can tell "backend sent nothing" apart from "backend sent something we don't recognise".
    const skippedMessageTypes = new Set();
    let streamError;
    let tilesBeforeStreamError;
    let tilesSent;
    try {
        for await (const chunk of generator){
            if (chunk.type === $eb2a414d1f8098e3$var$STREAM_ERROR_MESSAGE_TYPE) {
                streamError = chunk.message;
                tilesBeforeStreamError = tiles.length;
                continue;
            }
            if (chunk.type === (0, $bxkJA.PROMPT_TILES_FINAL_RESPONSE_STREAM_MESSAGE_TYPE)) {
                tilesSent = chunk.message.tiles_sent;
                continue;
            }
            if (chunk.type !== (0, $bxkJA.SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE)) {
                // The type says this can't happen, but the backend may add new message types.
                skippedMessageTypes.add(chunk.type);
                continue;
            }
            tiles.push(chunk.message);
            if (tiles.length === (0, $1pcs9.PRIMARY_PROMPTS_COUNT)) onPrimaryPromptsReady((0, $24YcB.getPrimaryPrompts)(tiles));
            if (tiles.length === maxTiles) {
                onSecondaryPromptsReady((0, $hEfoI.getSecondaryPrompts)(tiles));
                break;
            }
        }
    } catch (error) {
        if (tiles.length === 0) throw error;
    } finally{
        // If stream returns < maxTiles (on either success or partial failure), return whatever we have
        if (tiles.length < (0, $1pcs9.PRIMARY_PROMPTS_COUNT)) onPrimaryPromptsReady((0, $24YcB.getPrimaryPrompts)(tiles));
        if (tiles.length < maxTiles) onSecondaryPromptsReady((0, $hEfoI.getSecondaryPrompts)(tiles));
    }
    return {
        tiles: tiles.slice(0, maxTiles),
        skippedMessageTypes: Array.from(skippedMessageTypes),
        streamError: streamError,
        tilesBeforeStreamError: tilesBeforeStreamError,
        tilesSent: tilesSent
    };
};
const $eb2a414d1f8098e3$var$useStore = (0, $kBr4q.createHook)((0, $8VnnM.store));
const $eb2a414d1f8098e3$var$useStoreActions = (0, $kBr4q.createActionsHook)((0, $8VnnM.store));
const $eb2a414d1f8098e3$export$f54f772fbcec9a24 = ({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, thirdPartyPrompt: { enable3pPrompt: enable3pPrompt, ready: is3pReady } })=>{
    const { assistanceService: assistanceService } = assistanceServiceInjectedParams;
    const [state] = $eb2a414d1f8098e3$var$useStore();
    const { getState: getState, setLoading: setLoading, setPrimaryPrompts: setPrimaryPrompts, setSecondaryPrompts: setSecondaryPrompts, setData: setData, shuffleSuggestions: shuffleSuggestions, setError: setError } = $eb2a414d1f8098e3$var$useStoreActions();
    const loadSuggestions = (0, $cozmU.useCallback)(async ()=>{
        // Wait for the 3P signal to settle so we request a stable flag value (always
        // ready off a 3P surface); the host effect re-fires this when `is3pReady` flips.
        if (!is3pReady) return;
        const { isLoading: isLoading, data: data, error: error, primaryPrompts: primaryPrompts, secondaryPrompts: secondaryPrompts } = getState();
        if (isLoading || data || error || primaryPrompts || secondaryPrompts) return;
        setLoading();
        try {
            const { generator: generator } = await assistanceService.fetchPersonalizedPromptSuggestionsStream({
                offset: (0, $ewEzF.PROMPT_SUGGESTIONS_OFFSET),
                limit: $eb2a414d1f8098e3$var$TOTAL_PROMPT_SUGGESTIONS_COUNT,
                enable3pPrompt: enable3pPrompt
            });
            const { tiles: prompts, skippedMessageTypes: skippedMessageTypes, streamError: streamError, tilesBeforeStreamError: tilesBeforeStreamError, tilesSent: tilesSent } = await $eb2a414d1f8098e3$var$parsePromptSuggestionsStream({
                generator: generator,
                // The 3P tile comes on top of the `limit` prompts rather than inside them, so
                // the variants that asked for it must read one tile more than they requested.
                maxTiles: $eb2a414d1f8098e3$var$TOTAL_PROMPT_SUGGESTIONS_COUNT + (enable3pPrompt ? 1 : 0),
                onPrimaryPromptsReady: setPrimaryPrompts,
                onSecondaryPromptsReady: setSecondaryPrompts
            });
            if (prompts.length === 0) {
                if ((0, $iDrrr.fg)('rovo_chat_empty_prompt_tiles_fix')) {
                    // A backend ERROR message means the request failed partway through, so it must
                    // still count as a failure.
                    if (streamError) throw $eb2a414d1f8098e3$var$createStreamError(streamError);
                    // Only treat it as empty when the backend confirms it sent no tiles. That's an
                    // expected outcome (e.g. the user has no recent worked-on activity to personalise
                    // from). Keep surfacing it as `error` so hosts still fall back to static prompts,
                    // but type it so the loading experience doesn't count it as a failure.
                    if (tilesSent === 0) throw new (0, $4ONgd.PromptSuggestionsEmptyError)({
                        skippedMessageTypes: skippedMessageTypes
                    });
                }
                // Otherwise (no FINAL_RESPONSE, or it reports tiles we never received) keep
                // treating it as a failure.
                throw new Error('No prompt suggestions returned');
            }
            if (streamError && (0, $iDrrr.fg)('rovo_chat_empty_prompt_tiles_fix')) // The backend failed after sending some tiles. We still show the partial tiles,
            // but report the error so it isn't lost.
            (0, $hlvTd.logException)({
                exception: $eb2a414d1f8098e3$var$createStreamError(streamError),
                name: 'PromptSuggestionsPartialStreamError',
                tags: {
                    ...tilesBeforeStreamError !== undefined && {
                        tilesReceived: String(tilesBeforeStreamError)
                    },
                    ...streamError.status_code !== undefined && {
                        statusCode: String(streamError.status_code)
                    },
                    ...streamError.message_template && {
                        messageTemplate: streamError.message_template
                    }
                }
            });
            setData(prompts);
        } catch (err) {
            setError(err instanceof Error ? err : new Error('Failed to fetch prompt suggestions'));
        }
    }, [
        assistanceService,
        getState,
        setLoading,
        setPrimaryPrompts,
        setSecondaryPrompts,
        setData,
        setError,
        is3pReady,
        enable3pPrompt
    ]);
    return {
        ...state,
        enable3pPrompt: // Surfaced so the grid can hold the 3P tile's slot while it streams.
        enable3pPrompt,
        loadSuggestions: loadSuggestions,
        shuffleSuggestions: shuffleSuggestions
    };
};
module.exports["usePromptSuggestionsState"] = $eb2a414d1f8098e3$export$f54f772fbcec9a24;

});

parcelRegister("ewEzF", function(module, exports) {
const $ca811fa5aee98cee$export$a46b466313e421b7 = 0;
module.exports["PROMPT_SUGGESTIONS_OFFSET"] = $ca811fa5aee98cee$export$a46b466313e421b7;

});

parcelRegister("6UjGM", function(module, exports) {
const $08bf2d5a3c14e2fe$export$319bd1bf7b56ff21 = 6;
module.exports["SECONDARY_PROMPTS_COUNT"] = $08bf2d5a3c14e2fe$export$319bd1bf7b56ff21;

});

parcelRegister("cSCao", function(module, exports) {
/* AISmartCreateSpotlight.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $cJ0FD = parcelRequire("cJ0FD");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $4aRua = parcelRequire("4aRua");


var $lsxnT = parcelRequire("lsxnT");


var $9wGTI = parcelRequire("9wGTI");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $bzvdj = parcelRequire("bzvdj");


var $d22VI = parcelRequire("d22VI");


var $evORK = parcelRequire("evORK");


var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $9chzr = parcelRequire("9chzr");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $fc0094d2feaf8930$var$styles = {
    image: "_39xV02T1Vg _0jFU0V13wc _0KLXruotmK"
};
const $fc0094d2feaf8930$var$i18n = (0, $kSwu1.defineMessages)({
    smartCreateTitle: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.title",
        defaultMessage: "Start work faster with Rovo"
    },
    smartCreateDescription: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.description",
        defaultMessage: "Let Rovo draft the doc or whiteboard you need to get started fast."
    },
    smartCreateCTA: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.cta",
        defaultMessage: "Try it now"
    }
});
const $fc0094d2feaf8930$export$21865c28a29cfa2f = ({ children: children, onClick: onClick, source: source, isLoading: isLoading, offset: offset = [
    0,
    2
], placement: placement = 'left-start' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const handleSpotlightStart = (0, $cozmU.useCallback)(()=>{
        const statesToSet = [
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenAIFCSpotlight,
                value: 'true'
            },
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenDeeplinkReturnSpotlight,
                value: 'true'
            }
        ]; // Write to onboarding state (server-side persistence)
        setOnboardingState(statesToSet);
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AISmartCreateSpotlight',
                attributes: {
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        source
    ]);
    const handleSpotlightStop = ()=>{
        setIsSpotlightActive(false);
    };
    const choreographer = useChoreographer('AISmartCreateSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const { isAIFCOnbardingEligible: isChangboardingEligible, loading: isChangboardingEligibleLoading, error: isChangboardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS)), // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    !(0, $9wGTI.fg)('aifc_onboarding_killswitch'));
    const { hasSeenAIFCSpotlight: hasSeenAIFCSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const handleSpotlightInteraction = (0, $cozmU.useCallback)((e)=>{
        onClick?.(e);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightCTA',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        onClick,
        source
    ]);
    const handleOnClick = (0, $cozmU.useCallback)((e)=>{
        handleSpotlightInteraction(e);
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $cozmU.useCallback)(()=>{
        setIsSpotlightActive(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightDismiss',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        source
    ]);
    const getLocalOverrideValue = (0, $cozmU.useCallback)(()=>{
        try {
            if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY)) return true;
        } catch  {
            return false;
        }
        return false;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const localOverride = getLocalOverrideValue();
        const loadingComplete = !isLoading && !isChangboardingEligibleLoading && !isChangboardingEligibleError && !isOnboardingStateLoading && !isOnboardingStateError;
        if (loadingComplete && isChangboardingEligible && !hasSeenAIFCSpotlight) choreographer.startMessage();
        else if (localOverride) {
            handleSpotlightStart();
            (0, $17wUi.confluenceSessionStorageInstance).removeItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY);
        }
    }, [
        choreographer,
        hasSeenAIFCSpotlight,
        isLoading,
        isChangboardingEligible,
        isChangboardingEligibleError,
        isChangboardingEligibleLoading,
        isOnboardingStateError,
        isOnboardingStateLoading,
        getLocalOverrideValue,
        handleSpotlightStart
    ]);
    const CreateWithRovoSpotlightMedia = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fc0094d2feaf8930$var$styles.image
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d22VI))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bzvdj))),
            width: 295,
            height: 135,
            alt: ""
        }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9chzr.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: placement,
        offset: offset
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "ai-smart-create-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, CreateWithRovoSpotlightMedia), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: (e)=>handleOnClick(e)
        }, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateCTA))))); // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        return (0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: placement === 'right-end' ? 'right' : 'left'
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })())));
};
module.exports["AISmartCreateSpotlight"] = $fc0094d2feaf8930$export$21865c28a29cfa2f;

});

parcelRegister("bzvdj", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationDark.886221cf.gif", import.meta.url).toString();

});

parcelRegister("d22VI", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationLight.1a1df728.gif", import.meta.url).toString();

});

parcelRegister("aZaxv", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9i4uP = parcelRequire("9i4uP");


var $6mKj3 = parcelRequire("6mKj3");

const $2209b63ba8ad7190$export$c18a4b26e230200b = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { bannerState: bannerState } = (0, $9i4uP.useCreditsState)();
    let t0;
    if ($[0] !== bannerState) {
        t0 = bannerState?.balanceState === "depleted" && bannerState.depletionBehavior === "block" && (0, $6mKj3.expValEquals)("confluence_ubp_ai_credits", "isEnabled", true);
        $[0] = bannerState;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["useIsOutOfRovoCredits"] = $2209b63ba8ad7190$export$c18a4b26e230200b;

});

parcelRegister("2eyFz", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $a1ZzW = parcelRequire("a1ZzW");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $i8pw6 = parcelRequire("i8pw6");

const $4bdb3fad53788b3f$var$styles = {
    content: "_24h04i2Njc _39xV02JYcJ _4kiQYAM6FH _1EqgXlN91d _2fwxA5ecOK"
};
const $4bdb3fad53788b3f$var$CreditsPopupContent = ({ title: title, triggerLabel: triggerLabel, trigger: trigger, details: details, placement: placement = 'bottom-start', offset: offset, shouldRenderToParent: shouldRenderToParent = true })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $cozmU.useId)();
    const titleId = (0, $cozmU.useId)();
    const triggerId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        id: id,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        role: "dialog",
        titleId: title ? titleId : triggerId,
        placement: placement,
        offset: offset,
        shouldFitViewport: true,
        shouldRenderToParent: shouldRenderToParent,
        shouldUseCaptureOnOutsideClick: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                paddingBlock: "space.250",
                paddingInline: "space.400",
                xcss: $4bdb3fad53788b3f$var$styles.content
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "small",
                as: "h2",
                id: titleId
            }, title), details)),
        trigger: (triggerProps)=>{
            const buttonProps = {
                ...triggerProps,
                id: triggerId,
                isSelected: isOpen,
                onClick: ()=>setIsOpen((open)=>!open)
            };
            return trigger ? trigger(buttonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...buttonProps,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                        ...iconProps,
                        size: "medium"
                    }),
                label: triggerLabel
            });
        }
    });
};
const $4bdb3fad53788b3f$export$db75d6acad5af029 = ({ title: title, trigger: trigger, placement: placement, offset: offset, shouldRenderToParent: shouldRenderToParent, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i8pw6.CreditsSurface), props, ({ title: triggerLabel, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4bdb3fad53788b3f$var$CreditsPopupContent, {
            title: title,
            trigger: trigger,
            placement: placement,
            offset: offset,
            shouldRenderToParent: shouldRenderToParent,
            triggerLabel: triggerLabel,
            details: description
        }));
module.exports["CreditsPopup"] = $4bdb3fad53788b3f$export$db75d6acad5af029;

});

parcelRegister("2YLrg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $8NX7Q = parcelRequire("8NX7Q");

const $16dcc44e84baf717$export$a02021ad19526e53 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { source: source, isMenuOpen: t1 } = t0;
    const isMenuOpen = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== isMenuOpen) {
        t2 = !isMenuOpen || !(0, $9wGTI.fg)("cc_fd_agent_creation_connie_create_gate");
        $[0] = isMenuOpen;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== source || $[3] !== t2) {
        t3 = {
            source: source,
            skip: t2
        };
        $[2] = source;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { isEligible: isAgentCreationEligible, isLoading: isLoading } = (0, $8NX7Q.useCreateAgentEligibility)(t3);
    let t4;
    if ($[5] !== isAgentCreationEligible || $[6] !== isLoading) {
        t4 = (isAgentCreationEligible || isLoading) && (0, $6mKj3.expValEquals)("cc_inline_agent_create", "isEnabled", true);
        $[5] = isAgentCreationEligible;
        $[6] = isLoading;
        $[7] = t4;
    } else t4 = $[7];
    const shouldRenderInlineCreateAgentItem = t4;
    let t5;
    if ($[8] !== isAgentCreationEligible || $[9] !== isLoading) {
        t5 = (isAgentCreationEligible || isLoading) && (0, $6mKj3.expValEquals)("cc_fd_agent_creation_connie_create", "isEnabled", true);
        $[8] = isAgentCreationEligible;
        $[9] = isLoading;
        $[10] = t5;
    } else t5 = $[10];
    const shouldRenderStudioRedirectCreateAgentItem = t5;
    let t6;
    if ($[11] !== isLoading || $[12] !== shouldRenderInlineCreateAgentItem || $[13] !== shouldRenderStudioRedirectCreateAgentItem) {
        t6 = {
            shouldRenderInlineCreateAgentItem: shouldRenderInlineCreateAgentItem,
            shouldRenderStudioRedirectCreateAgentItem: shouldRenderStudioRedirectCreateAgentItem,
            isLoading: isLoading
        };
        $[11] = isLoading;
        $[12] = shouldRenderInlineCreateAgentItem;
        $[13] = shouldRenderStudioRedirectCreateAgentItem;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};
module.exports["useCreateAgentEntryPoint"] = $16dcc44e84baf717$export$a02021ad19526e53;

});

parcelRegister("8NX7Q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eGavN = parcelRequire("eGavN");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");





var $bQm3c = parcelRequire("bQm3c");


var $hZxtn = parcelRequire("hZxtn");

const $b2d6ff551541acfb$export$2e44e89f1245b022 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { source: source, skip: skip } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { hasBaseEligibility: hasBaseEligibility } = (0, $hZxtn.useCreateAgentBaseEligibility)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const shouldCheckAgentsPermissions = hasBaseEligibility && !skip;
    const t1 = cloudId ?? "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            cloudId: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !shouldCheckAgentsPermissions;
    let t4;
    let t5;
    if ($[2] !== createAnalyticsEvent || $[3] !== source) {
        t4 = (resp)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: source,
                    action: "success",
                    actionSubject: "studioPermissionsQuery",
                    actionSubjectId: "confluenceCreateMenu",
                    attributes: {
                        isAbleToCreateAgents: resp?.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents
                    }
                }
            }).fire();
        };
        t5 = (error)=>{
            if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error) && ((0, $1uFM6.isUnauthorizedError)(error) || error?.message.includes("Failed to fetch"))) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return;
            }
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: source,
                    action: "error",
                    actionSubject: "studioPermissionsQuery",
                    actionSubjectId: "confluenceCreateMenu",
                    attributes: {
                        errorMessage: error.message
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = source;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t2,
            skip: t3,
            fetchPolicy: "cache-first",
            interopApolloAggClient: true,
            onCompleted: t4,
            onError: t5
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $eGavN.default), {
        ...t6,
        __callerPackage__: "create-blank-fabric-page"
    });
    const hasPermission = data?.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents ?? false;
    const t7 = Boolean(shouldCheckAgentsPermissions && hasPermission);
    const t8 = shouldCheckAgentsPermissions && loading;
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = {
            isEligible: t7,
            isLoading: t8
        };
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
};
module.exports["useCreateAgentEligibility"] = $b2d6ff551541acfb$export$2e44e89f1245b022;

});

parcelRegister("eGavN", function(module, exports) {
/**
 * @generated SignedSource<<826ca50a71cc94d008e154a50661c920>>
 * @relayHash 1c649c09435fe6addb5727b0b9059b9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36624bb1365e392d7ecd9c799e3574b9a61a2293ba807ea94c0bfb6bc9c9324d
const $d586287eafa7fd92$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateAgentEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateAgentEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1c649c09435fe6addb5727b0b9059b9e",
            "id": "36624bb1365e392d7ecd9c799e3574b9a61a2293ba807ea94c0bfb6bc9c9324d",
            "metadata": {},
            "name": "useCreateAgentEligibilityQuery",
            "operationKind": "query",
            "text": "query useCreateAgentEligibilityQuery($cloudId:ID!){atlassianStudio_userSiteContext(cloudId:$cloudId){__typename,...on AtlassianStudioUserSiteContextOutput{userPermissions{isAbleToCreateAgents}}}}"
        }
    };
}();
$d586287eafa7fd92$var$node.hash = "bbbd0705674f2ed095a6b10ecef37220";
var $d586287eafa7fd92$export$2e2bcd8739ae039 = $d586287eafa7fd92$var$node;
module.exports["default"] = $d586287eafa7fd92$export$2e2bcd8739ae039;

});

parcelRegister("hZxtn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a9bd7aa765f91fba$export$be55a728f4607e26 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const t0 = isRovoLLMEnabled && !isAnonymousUser && !!cloudId;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            hasBaseEligibility: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["useCreateAgentBaseEligibility"] = $a9bd7aa765f91fba$export$be55a728f4607e26;

});

parcelRegister("2lkdI", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $88DFk = parcelRequire("88DFk");


var $hdBxM = parcelRequire("hdBxM");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $WwbQb = parcelRequire("WwbQb");


var $jyA9t = parcelRequire("jyA9t");

const $fbb092f598276ec2$var$INLINE_CREATE_AGENT_ACTION_SUBJECT_ID = 'inlineCreateAgentItem';
const $fbb092f598276ec2$var$INLINE_CREATE_AGENT_SOURCE_ID = 'confluence-inline-create-agent-menu';
const $fbb092f598276ec2$var$CONNIE_CREATE_SOURCE = 'connie-create';
const $fbb092f598276ec2$var$ROVO_SKILL_EXTENSION_TYPE = 'com.atlassian.rovo.skill';
const $fbb092f598276ec2$var$ROVO_SKILL_EXTENSION_KEY = 'skill:skillTag';
const $fbb092f598276ec2$export$720f90168f76454f = '__BUILD_AGENT_SKILL__';
const $fbb092f598276ec2$var$createInlineCreateAgentPrompt = (localizedPrompt)=>{
    const skillTokenIndex = localizedPrompt.indexOf($fbb092f598276ec2$export$720f90168f76454f);
    const hasSkillToken = skillTokenIndex !== -1;
    let textBefore = '';
    let textAfter = '';
    if (hasSkillToken) {
        textBefore = localizedPrompt.slice(0, skillTokenIndex);
        textAfter = localizedPrompt.slice(skillTokenIndex + $fbb092f598276ec2$export$720f90168f76454f.length).split($fbb092f598276ec2$export$720f90168f76454f).join('');
    } else if (localizedPrompt) textBefore = `${localizedPrompt} `;
    const content = [];
    if (textBefore) content.push({
        type: 'text',
        text: textBefore
    });
    content.push({
        type: 'inlineExtension',
        attrs: {
            extensionType: $fbb092f598276ec2$var$ROVO_SKILL_EXTENSION_TYPE,
            extensionKey: $fbb092f598276ec2$var$ROVO_SKILL_EXTENSION_KEY,
            parameters: {
                slug: 'build-agent'
            }
        }
    });
    if (textAfter) content.push({
        type: 'text',
        text: textAfter
    });
    return {
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: content
            }
        ]
    };
};
const $fbb092f598276ec2$var$createInlineCreateAgentSetContextPayload = (interactionSource)=>({
        type: 'set-message-context',
        source: $fbb092f598276ec2$var$INLINE_CREATE_AGENT_SOURCE_ID,
        interactionSource: interactionSource,
        product: 'confluence',
        openChat: false,
        data: {
            contextKey: (0, $WwbQb.INLINE_CREATE_AGENT_CONTEXT_KEY),
            setContext: (chatContext)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    ...typeof chatContext === 'object' && chatContext !== null ? chatContext : {},
                    flowKey: (0, $WwbQb.INLINE_CREATE_AGENT_FLOW_KEY)
                })
        }
    });
const $fbb092f598276ec2$var$createInlineCreateAgentChatNewPayload = (interactionSource, promptText)=>({
        type: 'chat-new',
        source: $fbb092f598276ec2$var$INLINE_CREATE_AGENT_SOURCE_ID,
        interactionSource: interactionSource,
        product: 'confluence',
        openChatMode: 'sidebar',
        data: {
            dialogues: [],
            prompt: $fbb092f598276ec2$var$createInlineCreateAgentPrompt(promptText),
            sourceId: $fbb092f598276ec2$var$INLINE_CREATE_AGENT_SOURCE_ID,
            skipCreatingSeededConversation: true,
            minionAlias: 'build-agent'
        }
    });
const $fbb092f598276ec2$export$e72a96bd1783d700 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, promptText: promptText, source: source } = t0;
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchPoint: $fbb092f598276ec2$var$CONNIE_CREATE_SOURCE
        };
        $[0] = t1;
    } else t1 = $[0];
    const [, t2] = (0, $88DFk.useRovoAgentCreateAnalytics)(t1);
    const { trackCreateSessionStart: trackCreateSessionStart } = t2;
    let t3;
    if ($[1] !== onClick || $[2] !== openModal || $[3] !== promptText || $[4] !== publish || $[5] !== source || $[6] !== trackCreateSessionStart) {
        t3 = ()=>{
            if ((0, $6mKj3.expValEquals)("cc_contextual_agent_creation_v2", "isEnabled", true)) {
                onClick($fbb092f598276ec2$var$INLINE_CREATE_AGENT_ACTION_SUBJECT_ID);
                if ((0, $9wGTI.fg)("sltns-1529-draft-agent-non-consequential")) trackCreateSessionStart();
                openModal({
                    entryPoint: source,
                    initialOutcomeType: "agent",
                    lockInitialOutcomeType: true
                });
                return;
            }
            publish($fbb092f598276ec2$var$createInlineCreateAgentSetContextPayload(source));
            publish($fbb092f598276ec2$var$createInlineCreateAgentChatNewPayload(source, promptText));
            onClick($fbb092f598276ec2$var$INLINE_CREATE_AGENT_ACTION_SUBJECT_ID);
        };
        $[1] = onClick;
        $[2] = openModal;
        $[3] = promptText;
        $[4] = publish;
        $[5] = source;
        $[6] = trackCreateSessionStart;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["INLINE_CREATE_AGENT_SKILL_TOKEN"] = $fbb092f598276ec2$export$720f90168f76454f;
module.exports["useInlineCreateAgentItemClickHandler"] = $fbb092f598276ec2$export$e72a96bd1783d700;

});

parcelRegister("1wMTi", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $c449b90ed6587660$var$INLINE_CREATE_AGENT_ACTION_SUBJECT_ID = 'inlineCreateAgentItem';
const $c449b90ed6587660$export$f67bf6dbc80ef2bb = (source)=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t0 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: $c449b90ed6587660$var$INLINE_CREATE_AGENT_ACTION_SUBJECT_ID,
                    attributes: {
                        source: source
                    }
                }
            }).fire();
        };
        t1 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["useInlineCreateAgentItemScreenEvent"] = $c449b90ed6587660$export$f67bf6dbc80ef2bb;

});


//# sourceMappingURL=GlobalCreateContentPopoverMenu.644d5609.js.map
